<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_5"></a>Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_Chapter1">Chapter 1:<span class="sp_toc">Organising the Home Front</span></a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter2" title="Link target outside of Sample">Chapter 2:<span class="sp_toc">Wartime Life</span></span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter3" title="Link target outside of Sample">Chapter 3:<span class="sp_toc">Evacuees and Bombing Raids</span></span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter4" title="Link target outside of Sample">Chapter 4:<span class="sp_toc">Wartime Crime</span></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter5" title="Link target outside of Sample">Chapter 5:<span class="sp_toc">Industry and Agriculture</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter6" title="Link target outside of Sample">Chapter 6:<span class="sp_toc">The Darlington Spitfire</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter7" title="Link target outside of Sample">Chapter 7:<span class="sp_toc">RAF Middleton St George</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter8" title="Link target outside of Sample">Chapter 8:<span class="sp_toc">Darlington Sailors</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter9" title="Link target outside of Sample">Chapter 9:<span class="sp_toc">Darlington Soldiers</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter10" title="Link target outside of Sample">Chapter 10:<span class="sp_toc1">Darlington &amp; Teesdale Airmen and WAAFs</span></span></h2>
<h2 class="toc1"><span href="#/xhtml/15_Endnotes" title="Link target outside of Sample"><em class="italic">Endnotes</em></span><a id="page_6"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?fd4d35ae